module.exports = __webpack_public_path__ + "img/Flag_of_Trinidad_and_Tobago.30180834.svg";